import { FC } from "react";
import styles from "./Selector.module.scss";
import { Switch } from "../Switch/Switch";

interface ISelectorProps {
    isEnabled: boolean;
    setIsEnabled: (isAvailable: boolean) => void;
    label: string;
    rightValue: string;
}

export const Selector: FC<ISelectorProps> = ({ 
    label, 
    isEnabled, 
    setIsEnabled,
    rightValue 
}) => {
    return (
        <div className={styles.selectorContainer}>
            <Switch
                label={label}
                isEnabled={isEnabled}
                setIsEnabled={setIsEnabled}
                alwaysActiveColor={true}
                isSelector={true}
            />
            <span onClick={ () => setIsEnabled(true) } className={styles.rightValue}>{rightValue}</span>
        </div>
    );
};